import React from 'react'
import { Link } from 'react-router-dom'
import type { LinkComponentProps } from '@pandiafi/components'

const isExternalHref = (href: string) => /^([a-z][a-z\d+.-]*:|\/\/)/i.test(href)

type ResidentAppRouterLinkProps = LinkComponentProps & {
  ref?: React.Ref<HTMLAnchorElement>
}

/**
 * Link adapter for the resident app components: they pass `href`, the router
 * wants `to`. External addresses (https:, mailto:, tel:) stay plain anchors.
 */
export const ResidentAppRouterLink: React.FC<ResidentAppRouterLinkProps> = ({
  href,
  ...props
}) => {
  if (isExternalHref(href)) {
    return <a href={href} {...props} />
  }

  return <Link to={href} {...props} />
}
